'use client';

import { useEffect, useState } from 'react';
import clsx from 'clsx';

import { FilterInGroupType } from '@/slw/entities/home/home.model';

import { ProductItem } from './product-item';
import { HeadingTitleContent } from './heading-title-content';

interface PartnerDealersProps {
  data: FilterInGroupType[];
}

export function PartnerDealers({ data = [] }: PartnerDealersProps) {
  const [tabActive, setTabActive] = useState<number>(0);
  const activeClasses = 'active font-bold bg-primary text-background';

  useEffect(() => {
    setTabActive(0);
  }, [data]);

  // const category = data?.[tabActive];

  if (!data?.length) {
    return <></>;
  }

  return (
    <section className='mt-10 md:mt-20'>
      <HeadingTitleContent title='Partner Dealers' />
      <div className='flex mb-6 md:mb-8 overflow-x-auto'>
        <div className='flex tabs border border-primary rounded-[8px] min-w-fit'>
          {data?.map((item, idx) => (
            <button
              key={idx}
              className={clsx(
                'px-3 md:px-4 py-2 cursor-pointer transition-all',
                tabActive === idx ? activeClasses : '',
                {
                  'rounded-tl-[6px] rounded-bl-[6px]': idx === 0,
                  'border-r border-primary': idx !== data.length - 1,
                  'rounded-tr-[6px] rounded-br-[6px]': (idx > 0 && idx === data.length - 1) || data.length === 1,
                },
              )}
              type='button'
              onClick={() => setTabActive(idx)}
            >
              {item.name}
            </button>
          ))}
        </div>
      </div>
      <div className='grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4 xl:gap-6'>
        {(data?.[tabActive]?.cars || []).map((item, idx) => (
          <ProductItem key={`${item.id}_${idx}`} item={item} />
        ))}
      </div>
      {/* <Link href={`/search-results/${category?.url}`} className='view-all font-medium text-primary block mt-3'>
        See more {category?.name}
      </Link> */}
    </section>
  );
}
